<template>
  <div
    class="
      tw-rounded-lg
      tw-size-full
      tw-flex
      tw-flex-col
      tw-justify-center
      tw-items-center
      tw-px-4
      tw-bg-sf-snow-lighter
    "
    data-testid="checks-empty-panel"
  >
    <div
      class="
        tw-w-[900px]
        tw-h-[400px]
        tw-flex
        tw-flex-col
        tw-gap-4
        tw-justify-center
        tw-items-center
      "
    >
      <img
        class="tw-max-w-[300px]"
        :src="$imagesRequire('empty_states/communication.svg')"
      />
      <div class="tw-font-medium tw-text-lg tw-text-sf-gray">
        {{ I18n.t('assistant_check.page.checks_container.empty.filter_title') }}
      </div>
      <div
        class="
          tw-inline-block
          tw-w-full
          tw-font-normal
          tw-text-sm
          tw-text-sf-gray
          tw-text-center
        "
      >
        <SfLink class="!tw-inline-block" @click="clearFilters">
          {{
            I18n.t(
              'assistant_check.page.checks_container.empty.filter_clear_action'
            )
          }}
        </SfLink>
        <span>
          {{
            I18n.t('assistant_check.page.checks_container.empty.filter_clear')
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfLink from '@app/shared/vue/components/sf-link.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useSfAssistantChecksPage } from '../stores/page'

const I18n = useI18n()

const { clearFilters } = useSfAssistantChecksPage()
</script>
